<template>
  <button type="button " v-bind:class="{ 'filter-checkbox': true, active: checked }" v-on:click="checkFilter" class="btn btn-sm mr-1">{{ title }}</button>
</template>
<script>
  export default {
    data () {
      return {
        checked: false
      }
    },
    props: [ 'title', 'category' ],
    methods: {
      checkFilter () {
        this.checked = !this.checked
        // this.$bus.$emit('check-filter', this.category, this.title, this.checked);
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/artworks/FilterCheckbox.vue